module.exports = __webpack_public_path__ + "img/progress_left.6ce70d50.svg";